import moment from 'moment';

import application from 'application/application';

import removeAccents from 'remove-accents';

application.value('API', {
	/*
		Para testar direto na homologação, altere o trecho de código abaixo nas correspondentes posições:
			-- hostname: 'homologacao-api.advise.com.br',  (para homolog)
			-- hostname: '#{api-hostname}#', (deixe como estava antes de realizar o push)
		Se for testar com api rodando no localhost:
			-- protocol: 'http:',
			-- hostname: 'localhost:XXXX',
			-- root: 'api/:version',
		*/
	default: {
		protocol: 'https:',
		hostname: '#{api-hostname}#',
		// hostname: 'homologacao-api.advise.com.br',
		// hostname: 'sandbox-api.advise.com.br',
		// hostname: 'api.advise.com.br',
		root: 'core/:version',
		version: 'v1'
	},
	keywords: {
		paths: {
			GET: 'palavras-chaves',
			POST: 'palavras-chaves',
			keywords: 'palavras-chaves/:ID'
		}
	},
	refreshToken: {
		root: 'login/:version',
		paths: {
			POST: 'refresh-token'
		}
	},
	login: {
		root: 'login/:version',
		paths: {
			POST: 'token',
			refreshToken: 'refresh-token'
		}
	},
	ticketLogin: {
		root: 'login/:version',
		paths: {
			POST: 'ticket/:idUsuarioCliente',
			GET: 'ticket/:ticket'
		}
	},
	logout: {
		root: 'login/:version',
		paths: {
			POST: 'log-out'
		}
	},
	briefcase: {
		paths: {
			GET: 'pastas-usuarios-clientes',
			POST: 'pastas-usuarios-clientes',
			PUT: 'pastas-usuarios-clientes',
			inativar: 'pastas-usuarios-clientes/inativar',
			DELETE: 'pastas-usuarios-clientes/desvincular-movimento',
			forward: 'pastas-usuarios-clientes/encaminhar',
			set: 'pastas-usuarios-clientes/vincular-movimento',
			keywords: 'pastas-usuarios-clientes/palavras-chave',
			processes: 'pastas-usuarios-clientes/processos-hub',
			filterName: 'pastas-usuarios-clientes/filtro-nome',
			filterKeywords: 'pastas-usuarios-clientes/filtro-palavra-chave'
		}
	},
	annotations: {
		paths: {
			GET: 'pastas-usuarios-clientes/:pasta/anotacoes',
			POST: 'pastas-usuarios-clientes/:pasta/anotacoes',
			PUT: 'pastas-usuarios-clientes/:pasta/anotacoes/:id',
			inativar: 'pastas-usuarios-clientes/:pasta/anotacoes/:id/inativar'
		}
	},
	clientUserDiaries: {
		paths: {
			GET: 'diarios-usuarios-clientes'
		}
	},
	notebook: {
		paths: {
			GET: 'cadernos-diarios'
		}
	},
	notebookUserGroup: {
		paths: {
			GET: 'cadernos-diarios/usuario-grupo'
		}
	},
	disableFolder: {
		paths: {
			PUT: 'pastas-usuarios-clientes/inativar'
		}
	},
	centerPay: {
		paths: {
			GET: 'central-pagamento/cobrancas'
		}
	},
	movements: {
		paths: {
			GET: 'movimentos-pastas-usuarios-clientes',
			POST: 'movimentos-pastas-usuarios-clientes',
			PUT: 'movimentos-pastas-usuarios-clientes',
			DELETE: 'movimentos-pastas-usuarios-clientes/:IDs',
			forward: 'movimentos-pastas-usuarios-clientes/encaminhar'
		},
		hooks: {
			request(request) {
				if (
					/^(?:POST|PUT)$/.test(request.method) &&
					request.data &&
					request.data.itens
				) {
					request.data.itens.forEach(item => {
						if (item.dataDia && item.dataHora)
							item.dataHoraAndamento = moment(
								`${item.dataDia}T${item.dataHora}`,
								'DD/MM/YYYYTHH:mm'
							).format();
					});
				}

				return request;
			},
			response(response) {
				((response.data && response.data.itens) || []).forEach(item => {
					if (item.dataHoraAndamento) {
						item.dataDia = moment(item.dataHoraAndamento).format('DD/MM/YYYY');

						item.dataHora = moment(item.dataHoraAndamento).format('HH:mm');
					}
				});

				return response;
			}
		}
	},
	movementsClients: {
		paths: {
			GET: 'movimentos-usuarios-clientes',
			POST: 'movimentos-usuarios-clientes'
		}
	},
	movementsClientsNotRead: {
		paths: {
			GET: 'movimentos-usuarios-clientes/total-nao-lidos'
		}
	},
	movementDetailsTypePublication: {
		paths: {
			GET: 'detalhes-movimentacoes/publicacoes'
		},
		hooks: {
			response(response) {
				response.data.itens.map(item => {
					// item.pastasMovimento.map(keyword => {
					item.palavrasChave.map(keyword => {
						let palavraChave = removeAccents(
								keyword.palavraChave
							).toLowerCase(),
							conteudo = removeAccents(item.conteudo).toLowerCase(),
							initString = conteudo.length;

						while (
							(initString = conteudo.lastIndexOf(
								palavraChave,
								initString - 1
							)) != -1
						) {
							item.conteudo =
								item.conteudo.substring(0, initString) +
								'<mark class="highlight">' +
								item.conteudo.substring(
									initString,
									initString + palavraChave.length
								) +
								'</mark>' +
								item.conteudo.substring(initString + palavraChave.length);

							if (initString == 0) return;
						}
					});
				});

				return response;
			}
		}
	},
	movementDetailsTypeProgress: {
		paths: {
			GET: 'detalhes-movimentacoes/andamentos'
		}
	},
	movementMarkAsRead: {
		paths: {
			PUT: 'movimento-processo-cliente-lido/marcar'
		}
	},
	movementMarkAsUnread: {
		paths: {
			PUT: 'movimento-processo-cliente-lido/desmarcar'
		}
	},
	requestedProcessesSameNumberRelatedProcess: {
		paths: {
			GET: 'processos-solicitados/proc-relacionados-mesmo-numero'
		}
	},
	requestedProcessesJudicialOrgans: {
		paths: {
			GET: 'processos-solicitados/orgaos-judiciarios'
		}
	},
	requestedProcessesSourcesParams: {
		paths: {
			GET: 'processos-solicitados/fontes-parametros'
		}
	},
	processesFonts: {
		paths: {
			GET: 'fontes-processos/possiveis-fontes'
		}
	},
	keyWordsVariations: {
		paths: {
			GET: 'usuario-cliente-palavras-chaves',
			POST: 'usuario-cliente-palavras-chaves',
			DELETE: 'usuario-cliente-palavras-chaves/:IDs',
			enable: 'usuario-cliente-palavras-chaves/ativar',
			disable: 'usuario-cliente-palavras-chaves/inativar',
			diaries: 'usuario-cliente-palavras-chaves/diarios-usuarios'
		}
	},
	peoplePic: {
		paths: {
			photo: 'pessoas-fotos',
			GET: 'pessoas',
			DELETE: 'pessoas-fotos'
		}
	},
	processes: {
		paths: {
			GET: 'processos',
			DELETE: 'processos/:IDs',
			archive: 'processos/arquivar'
		}
	},
	sourceAccessData: {
		paths: {
			GET: 'dado-acesso-fonte',
			POST: 'dado-acesso-fonte',
			PUT: 'dado-acesso-fonte',
			process: 'dado-acesso-fonte/processos',
			movements: 'inss/movimentos',
			DELETE: 'dado-acesso-fonte/excluir'
		}
	},
	deleteProcessINSS: {
		paths: {
			PUT: 'dado-acesso-fonte/pesquisa-processo/excluir'
		}
	},
	searchFontsProcess: {
		paths: {
			GET: 'fontes-pesquisa/lista-fonte-pesquisa-instituicao',
			processFilter: 'inss/filtro-processo'
		}
	},
	inssUpdateReadStatus: {
		paths: {
			READ: 'inss/marcar-movimentos-lido',
			UNREAD: 'inss/desmarcar-movimentos-lido'
		}
	},
	inssMovementsDetails: {
		paths: {
			GET: 'inss/movimentos-detalhes'
		}
	},
	inssProcessHeader: {
		paths: {
			GET: 'inss/cabecalhos-processo',
			detail: 'inss/detalhe-pesquisa-processo',
			updateAutomaticSource: 'busca-automatica-processo-usuario-cliente'
		}
	},
	inssFilter: {
		paths: {
			movementStatus: 'inss/filtro-andamento'
		}
	},
	processEnvolveds: {
		paths: {
			GET: 'processo-partes'
		}
	},
	processLawyers: {
		paths: {
			GET: 'processo-advogados'
		}
	},
	publications: {
		paths: {
			GET: 'publicacoes',
			setAsRead: 'publicacoes/marcar-como-lida',
			setAsUnread: 'publicacoes/marcar-como-nao-lida',
			favorite: 'publicacoes/favoritar',
			unfavorite: 'publicacoes/desfavoritar',
			download: 'publicacoes/download',
			archive: 'publicacoes/arquivar',
			forward: 'publicacoes/encaminhar',
			restore: 'publicacoes/restaurar'
		}
	},
	publicationsDeadlines: {
		paths: {
			POST: 'publicacoes-prazos',
			PUT: 'publicacoes-prazos'
		}
	},
	personContact: {
		paths: {
			GET: 'contatos',
			enable: 'contatos/ativar',
			disable: 'contatos/inativar',
			POST: 'contatos',
			PUT: 'contatos'
		}
	},
	personContactPhoto: {
		paths: {
			POST: 'contatos-fotos',
			GET: 'contatos-fotos/:id',
			DELETE: 'contatos-fotos'
		}
	},
	markContact: {
		paths: {
			GET: 'marcadores-contato',
			PUT: 'marcadores-contato',
			inativar: 'marcadores-contato/inativar'
		}
	},
	recurrenceTypes: {
		paths: {
			GET: 'tipos-recorrencia'
		}
	},
	reminderOptions: {
		paths: {
			GET: 'opcoes-lembrete'
		}
	},
	categoriesFinances: {
		paths: {
			GET: 'categorias-financeiro',
			POST: 'categorias-financeiro',
			PUT: 'categorias-financeiro',
			disable: 'categorias-financeiro/inativar',
			enable: 'categorias-financeiro/ativar'
		}
	},
	categoriesTypes: {
		paths: {
			GET: 'tipos-categorias-financeiro'
		}
	},
	people: {
		paths: {
			GET: 'pessoas'
		}
	},
	financesAccount: {
		paths: {
			GET: 'contas-financeiro'
		}
	},
	finances: {
		paths: {
			GET: 'financeiros'
		}
	},
	financeBalance: {
		paths: {
			GET: 'saldos-contas-financeiro',
			anual: 'saldos-contas-financeiro/mensal',
			saldoTotal: 'saldos-contas-financeiro/total'
		}
	},
	financeBalanceTotal: {
		paths: {
			GET: 'saldos-contas-financeiro/total'
		}
	},
	financeLow: {
		paths: {
			GET: 'baixas-financeiro',
			POST: 'baixas-financeiro',
			PUT: 'baixas-financeiro',
			disable: 'baixas-financeiro/inativar'
		}
	},
	releases: {
		paths: {
			GET: 'lancamentos-financeiro',
			POST: 'lancamentos-financeiro',
			PUT: 'lancamentos-financeiro'
		}
	},
	installments: {
		paths: {
			GET: 'parcelas-financeiro',
			disable: 'parcelas-financeiro/inativar'
		}
	},
	forgotPassword: {
		root: 'login/:version',
		paths: {
			POST: 'redefinir-senha',
			PUT: 'alterar-senha'
		}
	},
	userKeywords: {
		paths: {
			GET: 'usuario-palavras-chave'
		}
	},
	userVariations: {
		paths: {
			GET: 'usuario-variacoes'
		}
	},
	userDiaries: {
		paths: {
			GET: 'usuario-diarios'
		}
	},
	diaries: {
		paths: {
			GET: 'diarios',
			searchPublication: 'diarios/usuario-grupo'
		}
	},
	OABTypes: {
		paths: {
			GET: 'tipos-oab'
		}
	},
	usersCustomers: {
		paths: {
			GET: 'usuarios-clientes',
			PUT: 'usuarios-clientes',
			ChangePassword: 'usuarios/usuario-logado-alterar-senha',
			ChangeEmail: 'usuarios/usuario-logado-alterar-email',
			acceptTerms: 'usuarios-clientes/aceitar-termos-uso',
			acceptTermsCurrent: 'usuarios-clientes/valida-aceite-termo-vigente'
		},
		hooks: {
			request(request) {
				if (
					/^(?:POST|PUT)$/.test(request.method) &&
					request.data &&
					request.data.itens
				) {
					request.data.itens.forEach(item => {
						if (item.pessoa && item.pessoa.dataNascimentoAbertura)
							item.pessoa.dataNascimentoAbertura = moment(
								item.pessoa.dataNascimentoAbertura,
								'DD/MM/YYYY'
							).format();

						if (item.pessoa && item.pessoa.cep)
							item.pessoa.cep = item.pessoa.cep.replace(
								/^(\d{5})\-?(\d{3})$/,
								'$1$2'
							);
					});
				}

				return request;
			},
			response(response) {
				((response.data && response.data.itens) || []).forEach(item => {
					if (item.pessoa && item.pessoa.dataNascimentoAbertura)
						item.pessoa.dataNascimentoAbertura = moment(
							item.pessoa.dataNascimentoAbertura
						).format('DD/MM/YYYY');

					if (item.pessoa && item.pessoa.cep)
						item.pessoa.cep = item.pessoa.cep.replace(
							/^(\d{5})\-?(\d{3})$/,
							'$1-$2'
						);
				});

				return response;
			}
		}
	},
	disableUsersCustomers: {
		paths: {
			PUT: 'usuarios-clientes/inativar'
		}
	},
	customers: {
		paths: {
			GET: 'clientes',
			PUT: 'clientes'
		},
		hooks: {
			request(request) {
				if (
					/^(?:POST|PUT)$/.test(request.method) &&
					request.data &&
					request.data.itens
				) {
					request.data.itens.forEach(item => {
						if (item.pessoaCliente && item.pessoaCliente.dataNascimentoAbertura)
							item.pessoaCliente.dataNascimentoAbertura = moment(
								item.pessoaCliente.dataNascimentoAbertura,
								'DD/MM/YYYY'
							).format();

						if (item.pessoaCliente && item.pessoaCliente.cep)
							item.pessoaCliente.cep = item.pessoaCliente.cep.replace(
								/^(\d{5})\-?(\d{3})$/,
								'$1$2'
							);

						if (
							item.pessoaCliente &&
							item.pessoaCliente.idTipoPessoa &&
							item.pessoaCliente.cpfcnpj
						) {
							if (item.pessoaCliente.idTipoPessoa == -1)
								item.pessoaCliente.cpfcnpj = item.pessoaCliente.cpfcnpj.replace(
									/^(\d{3})\.?(\d{3})\.?(\d{3})\-?(\d{2})$/,
									'$1$2$3$4'
								);

							if (item.pessoaCliente.idTipoPessoa == -2)
								item.pessoaCliente.cpfcnpj = item.pessoaCliente.cpfcnpj.replace(
									/^(\d{2})\.?(\d{3})\.?(\d{3})\/?(\d{4})\-?(\d{2})$/,
									'$1$2$3$4$5'
								);
						}
					});
				}

				return request;
			},
			response(response) {
				((response.data && response.data.itens) || []).forEach(item => {
					if (item.pessoaCliente && item.pessoaCliente.dataNascimentoAbertura)
						item.pessoaCliente.dataNascimentoAbertura = moment(
							item.pessoaCliente.dataNascimentoAbertura
						).format('DD/MM/YYYY');

					if (item.pessoaCliente && item.pessoaCliente.cep)
						item.pessoaCliente.cep = item.pessoaCliente.cep.replace(
							/^(\d{5})\-?(\d{3})$/,
							'$1-$2'
						);

					if (
						item.pessoaCliente &&
						item.pessoaCliente.idTipoPessoa &&
						item.pessoaCliente.cpfcnpj
					) {
						if (item.pessoaCliente.idTipoPessoa == -1)
							item.pessoaCliente.cpfcnpj = item.pessoaCliente.cpfcnpj.replace(
								/^(\d{3})\.?(\d{3})\.?(\d{3})\-?(\d{2})$/,
								'$1.$2.$3-$4'
							);

						if (item.pessoaCliente.idTipoPessoa == -2)
							item.pessoaCliente.cpfcnpj = item.pessoaCliente.cpfcnpj.replace(
								/^(\d{2})\.?(\d{3})\.?(\d{3})\/?(\d{4})\-?(\d{2})$/,
								'$1.$2.$3/$4-$5'
							);
					}
				});

				return response;
			}
		}
	},
	genders: {
		paths: {
			GET: 'sexo'
		}
	},
	notificationsOptions: {
		paths: {
			GET: 'opcoes-notificacoes',
			PUT: 'opcoes-notificacoes'
		}
	},
	notificationsEmails: {
		paths: {
			GET: 'emails-usuario-cliente',
			POST: 'emails-usuario-cliente',
			disable: 'emails-usuario-cliente/inativar'
		}
	},
	cancelEmails: {
		paths: {
			POST: 'cancelamento-envio-email',
			confirm: 'cancelamento-envio-email/validar-codigo'
		}
	},
	federativeUnits: {
		paths: {
			GET: 'uf'
		}
	},
	cities: {
		paths: {
			GET: 'municipios'
		}
	},
	judicialBranches: {
		paths: {
			GET: 'orgao-judiciario'
		}
	},
	degreesJurisdiction: {
		paths: {
			GET: 'grau-jurisdicao'
		}
	},
	sourceParamsCNJ: {
		paths: {
			// GET: 'fontes-parametros-cnj-outros'
			GET: 'fontes-processos/possiveis-fontes'
		}
	},
	searchFontsProcessClients: {
		paths: {
			POST: 'fontes-pesquisas-processos-clientes'
		}
	},
	permissions: {
		paths: {
			GET: 'permissoes-usuario-cliente'
		}
	},
	userClientFunctionalities: {
		paths: {
			GET: 'usuario-cliente-funcionalidade/consultar-credito'
		}
	},

	foundProcesses: {
		paths: {
			GET: 'processos-encontrados-usuario-cliente',
			total: 'processos-encontrados-usuario-cliente/total-processos'
		}
	},
	contracts: {
		paths: {
			GET: 'contratos'
		}
	},
	contractsNew: {
		paths: {
			GET: 'contratos'
		},
		version: 'v2'
	},
	processHeaders: {
		paths: {
			GET: 'cabecalhos-processos'
		}
	},
	userCustomerAutomaticSearch: {
		paths: {
			PUT: 'busca-automatica-processo-usuario-cliente'
		}
	},
	agendas: {
		paths: {
			GET: 'agendas'
		}
	},
	eventsTypes: {
		paths: {
			GET: 'tipos-eventos'
		}
	},
	eventCategories: {
		paths: {
			GET: 'categorias-agenda',
			POST: 'categorias-agenda',
			ativar: 'categorias-agenda/:id/ativar',
			inativar: 'categorias-agenda/:id/inativar'
		}
	},
	defaultEventTypes: {
		paths: {
			GET: 'tipos-eventos-padroes'
		}
	},
	agendaReminderTypes: {
		paths: {
			GET: 'tipos-lembretes-eventos'
		}
	},
	recurringDeadlineEventTypes: {
		paths: {
			GET: 'tipos-repeticao-eventos'
		}
	},
	deleteAgendaEvent: {
		paths: {
			PUT: 'eventos-agenda/inativar'
		}
	},
	deadlineEvents: {
		paths: {
			GET: 'eventos-agenda',
			PUT: 'eventos-agenda',
			POST: 'eventos-agenda',
			ativar: 'eventos-agenda/ativar',
			inativar: 'eventos-agenda/inativar',
			vincular: 'eventos-agenda/vincular-movimento',
			desvincular: 'eventos-agenda/desvincular-movimento',
			diasEventos: 'eventos-agenda/dias-mes-evento',
			total: 'eventos-agenda/total',
			marcarImportante: 'eventos-agenda/marcar-importante',
			desmarcarImportante: 'eventos-agenda/desmarcar-importante',
			marcarConcluido: 'eventos-agenda/marcar-concluido',
			desmarcarConcluido: 'eventos-agenda/desmarcar-concluido'
		}
	},
	deadlines: {
		paths: {
			GET: 'agendas'
		}
	},
	agenda: {
		protocol: 'https:',
		hostname: 'mockgerenciador-opuhfpgkuw.now.sh',
		root: 'api-lite/:version',
		version: 'v1',
		paths: {
			GET: 'agenda'
		}
	},
	email: {
		paths: {
			ongoing: 'envio-email-andamentos',
			movements: 'envio-email-movimentos',
			publications: 'envio-email-publicacoes',
			prazos: 'envio-email-prazos',
			contato: 'envio-email-contatos',
			parcelas: 'envio-email-parcelas',
			cashFlow: 'envio-email-saldo-conta-financ',
			cashFlowYear: 'envio-email-saldo-conta-financ/mensal',
			subpoena: 'envio-email-intimacoes'
		}
	},
	attachmentDownload: {
		paths: {
			GET: 'anexo-fonte-processo/:ID'
		}
	},
	downloads: {
		paths: {
			ongoing: 'andamentos-download',
			movements: 'movimentos-download',
			publications: 'publicacoes-download',
			releases: 'parcelas-download',
			contacts: 'contatos-download',
			all: 'movimentos-download/todos',
			deadlines: 'prazos-download',
			cashFlow: 'saldos-contas-financeiro/download',
			cashFlowYear: 'saldos-contas-financeiro/download/mensal',
			subpoena: 'intimacoes-download',
			allSubpoenas: 'intimacoes-download/todos'
		}
	},
	actionEvents: {
		paths: {
			GET: 'acoes-eventos'
		}
	},
	actionUserEvents: {
		paths: {
			GET: 'acoes-eventos-usuarios',
			PUT: 'acoes-eventos-usuarios',
			POST: 'acoes-eventos-usuarios'
		}
	},
	actionEventClientUser: {
		paths: {
			GET: 'acao-evento-usuario-cliente',
			PUT: 'acao-evento-usuario-cliente'
		}
	},
	products: {
		paths: {
			GET: 'produtos-advise'
		}
	},
	integracaoGoogleCalendar: {
		paths: {
			GET: 'integracao-google-calendar',
			PUT: 'integracao-google-calendar',
			POST: 'integracao-google-calendar'
		}
	},
	agendaGoogleCalendar: {
		paths: {
			GET: 'agenda-google-calendar',
			PUT: 'agenda-google-calendar',
			POST: 'agenda-google-calendar',
			sincronizar: 'agenda-google-calendar/sincronizar',
			dessincronizar: 'agenda-google-calendar/dessincronizar'
		}
	},
	clientFeatures: {
		paths: {
			GET: 'funcionalidades-clientes'
		}
	},
	keyWordsClient: {
		paths: {
			POST: 'palavra-chave-cliente/inserir',
			GET: 'palavra-chave-cliente/consultar',
			PUT: 'palavra-chave-cliente/atualizar',
			alterarSituacao: 'palavra-chave-cliente/alterar-situacao',
			alterarSituacaoVariacao: 'palavra-chave-cliente/alterar-situacao-variacao'
		}
	},
	searchPublicationUserClient: {
		paths: {
			GET: 'pesquisa-publicacao/consultar',
			palavraChaveConsultar: 'pesquisa-publicacao/palavras-chave-principal',
			diarioConsultar: 'pesquisa-publicacao/diarios-palavra-chave',
			POST: 'pesquisa-publicacao/inserir-atualizar',
			palavraChaveVariacoes: 'palavra-chave-cliente/:ID/variacoes'
		}
	},
	itemsPerPageQuantity: {
		paths: {
			GET: 'qtd-itens-pagina',
			PUT: 'qtd-itens-pagina',
			POST: 'qtd-itens-pagina'
		}
	},
	groupUsers: {
		paths: {
			GET: 'grupo-usuarios',
			POST: 'grupo-usuarios',
			PUT: 'grupo-usuarios',
			alterarSituacao: 'grupo-usuarios/alterar-situacao'
		}
	},
	groupXUsers: {
		paths: {
			GET: 'usuarios-grupos',
			POST: 'usuarios-grupos',
			PUT: 'usuarios-grupos',
			inativar: 'usuarios-grupos/inativar'
		}
	},
	termsUse: {
		paths: {
			GET: 'termos/termo-uso-vigente'
		}
	},
	termsUseVersion: {
		paths: {
			GET: 'termos/:Id'
		}
	},
	clients: {
		paths: {
			GET: 'clientes/contratos'
		}
	},
	queryCep: {
		paths: {
			GET: 'consulta-cep'
		}
	},
	trashCan: {
		paths: {
			send: 'movimentos-usuarios-clientes/enviar-lixeira',
			sendByFolders: 'movimentos-pastas-usuarios-clientes/enviar-lixeira',
			restore: 'movimentos-usuarios-clientes/restaurar-lixeira'
		}
	},
	generalParameters: {
		paths: {
			GET: 'parametros-gerais'
		}
	},
	modalSearch: {
		paths: {
			GET: 'modal-pesquisa/controle-modal',
			POST: 'modal-pesquisa/participar'
		}
	},
	permissionsMovimentacoes: {
		paths: {
			GET: 'controle-usuario-evento-futuro',
			POST: 'controle-usuario-evento-futuro',
			PUT: 'controle-usuario-evento-futuro/alterar-lido'
		}
	},
	subpoena: {
		paths: {
			consultaAcessos: 'intimacao/ConsultaCadastroAcessos',
			consultaIntimacao: 'intimacao/ConsultaListaIntimacoes',
			consultaDetalhe: 'intimacao/ConsultaDetalhe',
			consultaFonte: 'intimacao/ConsultaFonteIntimacoes',
			POST: 'intimacao',
			ativar: 'intimacao/ativar-pesquisa',
			inativar: 'intimacao/inativar-pesquisa',
			excluirPesquisa: 'intimacao/excluir-pesquisa',
			consultaOrgao: 'intimacao/consulta-orgao-judiciario',
			cadastrarCertificado: 'certificados-digitais/a1/cadastrar'
		}
	},
	consultaOabRj: {
		paths: {
			GET: 'SituacaoConvenioOABRJ/consultar'
		}
	},
	cadastroAgil: {
		paths: {
			GET: 'cadastro-agil/consultar-oab-cna',
			POST: 'cadastro-agil/cadastrar-descoberta',
			fetchNotifications: 'cadastro-agil/consultar-descoberta-usuario-cliente'
		}
	},
	recoverPastDeadlines: {
		paths: {
			POST: 'controle-usuario-google-calendario'
		}
	},
	parametersUsers: {
		paths: {
			GET: 'parametros-usuario',
			PUT: 'parametros-usuario',
			POST: 'parametros-usuario'
		}
	},
	defaultNotification: {
		paths: {
			GET: 'notificacoes',
			POST: 'notificacoes',
			getNotRead: 'notificacoes/nao-lidas',
			putMarkAsRead: 'notificacoes/marcar-lida',
			putDeleteNotification: 'notificacoes/excluir',
			putDeleteAll: 'notificacoes/excluir/todas'
		}
	},
	debit: {
		paths: {
			POST: 'calculos/token'
		}
	},
	parts: {
		paths: {
			getToken: 'pecas/token',
			refreshToken: 'pecas/refreshtoken',
			getCredits: 'pecas/creditos/sincronizar'
		}
	},
	quickRegister: {
		paths: {
			getInfoAbstract: 'cadastro-agil/informacoes-resumo',
			getInfoSearch: 'cadastro-agil/informacoes-pesquisa',
			putImportProcess: 'cadastro-agil/importar-processos',
			getSituacaoPesquisa:
				'cadastro-agil/classificacao-situacoes-processo-pesquisa'
		}
	}
});
